import React, { useEffect } from 'react';
import './Page.scss';
import { Container, Row, Col } from 'react-bootstrap';
import Loading from '../../Components/Loading/Loading';
import { baseUrl } from '../../api/api';
import ResearchPublications from '../../Components/Pages/ResearchPublications';
import ResearchActivities from '../ResearchActivities/ResearchActivities';

const Page = props => {

    const [loading, setLoading] = React.useState(true);
    const [pageData, setPageData] = React.useState({});
    const fetchData = async () => {
        setLoading(true)

        const requestOptions = {
            method: "GET",
            redirect: "follow"
        };

        await fetch(`${baseUrl}/pages?_where[0][slug]=${props.match.params.slug}`, requestOptions)
            .then((response) => response.json())
            .then((result) => setPageData(result?.[0] || undefined))
            .catch((error) => console.error(error));
        setLoading(false)

    }

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.match.params.slug])


    return (
        <React.Fragment>
            <div className="blog-page">
                {!loading && pageData &&
                    <div>
                        <div className='page-title'>
                            <h1 style={{ color: "white", textAlign: "center", padding: "40px 40px" }}>{pageData?.title}</h1>
                        </div>
                        <Container className="blog-wrapper">
                            <Row className="mb-5">

                                <Col lg={12}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: pageData.content ? pageData.content : ''
                                        }}
                                    />


                                </Col>
                            </Row>
                        </Container>
                    </div>
                }
                {['research-publication', 'internal-publication', 'external-publication']?.includes(props.match.params.slug) && <ResearchPublications slug={props.match.params.slug} />}
                {props.match.params.slug === 'research-activities' && <ResearchActivities />}
                <Row className="my-5 justify-content-center">
                    {loading &&
                        <Loading />
                    }

                    {/* {!loading && !pageData &&
                        <EmptyHolder text="Page not found" />
                    } */}
                </Row>
            </div>
        </React.Fragment>
    )
}

export default Page;